var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.valid)?_c('div',[_c('v-divider',{staticClass:"my-10"}),_c('v-btn',{attrs:{"color":"error","small":"","outlined":"","loading":_vm.loading},on:{"click":_vm.handleDelete}},[_vm._v("Delete this Post")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }